// import env from 'webpack' /* note: this is done automatically at compile time */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('snakeymouse')
);
